<template>
    <div class="pop_overlay_black" v-if="isShow">
        <div class="pop_wrap rsv_color_edit loading_top_wrap" style="width: 405px;">
            <div v-if="isLoading" class="loading_bg" style="z-index: 999;">
                <div class="loading_wrap">
                    <div class="loading_obj">
                        <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66"
                             xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33"
                                    r="30">
                            </circle>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="pop_title">
                <span class="title">{{ $t('popup_color.title') }}</span>
                <button class="mgl_auto" @click="action_ClosePopup">
                    <v-icon large>mdi-close</v-icon>
                </button>
            </div>
            <div class="pop_cont">
                <div class="form_list" style="height: 140px;">
                    <div class="title">{{ $t('popup_color.label_color') }}</div>
                    <div class="cont">
                        <div class="cell_palette">
                            <span class="color_circle" v-for="(c, index) in palette" :key="index"
                                  :class="{ 'on' : hasSelection(c), 'white_txt' : !isLightBackground }"
                                  :style="getBackgroundStyle(c)"
                                  @click="action_SelectColor(c)"
                            >
                                <v-icon x-small v-if="hasSelection(c)">mdi-check-bold</v-icon>
                            </span>
                            <hr>
                            <div class="custom_color" @click="action_ShowColorPicker"
                                 @click.stop="action_ShowColorPicker">
                                <span class="color_circle custom" v-if="!isCustomSelection" />
                                <span class="color_circle on"
                                      v-if="isCustomSelection"
                                      :class="{ 'white_txt' : !isLightBackground }"
                                      :style="getBackgroundStyle(selectedColor)">
                                    <v-icon x-small>mdi-check-bold</v-icon>
                                </span>
                                {{ $t('popup_color.placeholder_color') }}
                            </div>
                            <small class="red_txt" v-if="isNotSelectedError">{{ $t('popup_color.label_color_error') }}</small>
                            <div class="work_code_color_picker" v-clickoutside:action_HideColorPicker="{}">
                                <ColorPicker v-if=isShowPicker ref="ColorPicker"
                                             v-model="pickerHexString"
                                             @updateHandleMouseEvent=updateHandleMouseEvent
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="form_list">
                    <div class="title">{{ $t('popup_color.label_memo') }}</div>
                    <div class="cont">
                        <textarea rows="5" :placeholder="$t('popup_color.placeholder_memo')" class="w_full" maxlength="300"
                                  v-model="note" />
                    </div>
                </div>
                <div class="btn_wrap pdt_20">
                    <button class="btn btn_l btn_blue" @click="action_Save">{{ $t('popup_color.button_save') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import { sheetState } from '../../../sheet-state'
import { closeColorEditPopup, hideCellMenu, sheetOverlays } from '../../../sheet-overlays'
import { exitTimeSelectMode } from '../../../reservation-selection'
import { sheetAxis } from '../../../sheet-axis'
import { sheetFilters, selectedColumns, selectedGroups } from '../../../sheet-filters'
import ColorPicker from '../WorkStatePopup/Popups/ColorPicker/ColorPicker.vue'
import moment from '@/util/MPMoment'
import { useV2ReservationCellCreateMutation } from '@/composables/queries/v2reservationcell/use-v2-reservationcell-create-mutation'
import { useV2ReservationCellUpdateMutation } from '@/composables/queries/v2reservationcell/use-v2-reservationcell-update-mutation'

export default {
    setup() {
        const { mutateAsync: createReservationCell } = useV2ReservationCellCreateMutation()
        const { mutateAsync: updateReservationCell } = useV2ReservationCellUpdateMutation()
        return { createReservationCell, updateReservationCell }
    },
    components: { ColorPicker },
    props: {
        selectedAreaHelper: Object
    },
    data() {
        return {
            sheetState,
            sheetOverlays,
            sheetAxis,
            sheetFilters,
            selectedColor: '',
            note: '',
            pickerHexString: { hex: undefined },
            isLoading: false,
            isCustomSelection: false,
            isShowPicker: false,
            isNotSelectedError: false,
            isHandleMouseEvent: false,

            range: undefined
        }
    },
    watch: {
        isShow: {
            handler: function (newValue) {
                if (!newValue) {
                    this.initialData()
                    this.removeEventListener()
                } else {
                    this.addEventListener()
                    this.range = this.selectedAreaHelper.selectedRange
                }
            }
        },
        selectedColor: {
            handler: function () {
                this.isNotSelectedError = false
            }
        },
        cell: {
            handler: function (newValue) {
                if (newValue == undefined) return
                this.note = newValue.note ?? ''
                this.selectedColor = newValue.usingCustomColor ? newValue.customColorCode : this.palette[newValue.paletteIndex]
                this.isCustomSelection = newValue.usingCustomColor
            }
        },
        'pickerHexString.hex': {
            handler: function (newValue, oldValue) {
                if (!newValue || newValue == oldValue) return
                this.isCustomSelection = true
                this.selectedColor = newValue
            }
        }
    },
    computed: {
        isShow: function () {
            return this.sheetOverlays.isShowColorEditPopup
        },
        cell: function () {
            return this.sheetOverlays.selectedColorCell
        },
        isUpdating: function () {
            return this.cell != undefined
        },
        palette: function () {
            return this.sheetState.reservationSetting?.cellColorPaletteID?.basicPalette
        },
        timeInterval: function () {
            return this.sheetAxis.selectedTimeInterval
        },
        timeArray: function () {
            return this.sheetAxis.timeArray
        },
        selectedDate: function () {
            return this.sheetAxis.selectedDate
        },
        filteredColumns: function () {
            let groups = deepCopy(selectedGroups())

            return groups.sort((l, r) => (l?.order) ?? 0 - (r?.order ?? 0))
                .reduce((acc, group) => {
                    let ids = selectedColumns()
                        .filter((c) => c.isSelected && c.groupID == group._id)

                    acc.push(ids.length > 0 ? ids : { _id: undefined })
                    return acc
                }, []).flat()
        },
        selectedColumnIds: function () {
            let start = Math.min(this.range.start.x, this.range.end.x)
            let end = Math.max(this.range.start.x, this.range.end.x)
            return this.filteredColumns.slice(start, end + 1).filter(c => c._id != undefined).map(c => c._id)
        },
        startedAt: function () {
            let index = Math.min(this.range.start.y, this.range.end.y)
            let m = moment(this.selectedDate).add(this.timeArray[index].time.hours(), 'hours').add(this.timeArray[index].time.minutes(), 'minutes')
            return m.toString()
        },
        endedAt: function () {
            let index = Math.max(this.range.start.y, this.range.end.y)
            let m = moment(this.timeArray[index].time).add(this.timeInterval, 'minutes')
            return m.toString()
        },
        brightness: function () {
            let color = this.selectedColor?.slice(1) ?? '#FF0000'
            let rgb = parseInt(color, 16)
            let r = (rgb >> 16) & 0xff
            let g = (rgb >> 8) & 0xff
            let b = (rgb >> 0) & 0xff
            return 0.299 * r + 0.587 * g + 0.114 * b
        },
        isLightBackground: function () {
            return this.brightness > 111
        }
    },
    methods: {
        initialData() {
            this.note = ''
            this.selectedColor = ''
            this.isCustomSelection = false
            this.isShowPicker = false
            this.isNotSelectedError = false
            this.isHandleMouseEvent = false
            this.pickerHexString = { hex: undefined }
        },
        getBackgroundStyle(color) {
            return `background-color:${ color };`
        },
        hasSelection(color) {
            return this.selectedColor == color && !this.isCustomSelection
        },
        action_SelectColor(color) {
            this.selectedColor = color
            this.isCustomSelection = false
        },
        action_ShowColorPicker() {
            this.isShowPicker = true
        },
        action_HideColorPicker() {
            if (this.isShowPicker && !this.isHandleMouseEvent) {
                this.isShowPicker = false
            }
        },
        action_ClosePopup() {
            hideCellMenu()
            closeColorEditPopup()
        },
        action_Save() {
            if (!this.selectedColor) {
                this.isNotSelectedError = true
            } else {
                this.requestCreateOrUpdateReservationCell()
            }
        },
        // MARK :- Network
        async requestCreateOrUpdateReservationCell() {
            if (this.isLoading) return
            this.isLoading = true

            try {
                let id = this.cell?._id
                let hospitalID = this.hospital.selectedHospital._id
                let date = moment(this.isUpdating ? this.cell.date : this.selectedDate).startOf('days').toString()
                let columns = this.isUpdating ? this.cell.columns : this.selectedColumnIds
                let startedAt = this.isUpdating ? moment(this.cell.startedAt).toString() : this.startedAt
                let endedAt = this.isUpdating ? moment(this.cell.endedAt).toString() : this.endedAt


                let params = {
                    _id: id,
                    hospitalID: hospitalID,
                    date: date,
                    note: this.note,
                    columns: columns,
                    startedAt: startedAt,
                    endedAt: endedAt,
                    usingCustomColor: this.isCustomSelection,
                    ...(this.isCustomSelection ? { customColorCode: this.selectedColor } : {}),
                    ...(!this.isCustomSelection && this.palette.indexOf(this.selectedColor) != -1 ? { paletteIndex: this.palette.indexOf(this.selectedColor) } : {})
                }

                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                await (this.isUpdating ? this.updateReservationCell(params) : this.createReservationCell(params))
                this.handleSuccessCallback()
            } catch (err) {
                console.log('Error processing creating: ', err)
            } finally {
                this.isLoading = false
            }
        },
        handleSuccessCallback() {
            exitTimeSelectMode()
            this.action_ClosePopup()
        },
        addEventListener() {
            window.addEventListener('keyup', this.handleKeyUp)
        },
        removeEventListener() {
            window.removeEventListener('keyup', this.handleKeyUp)
        },
        handleKeyUp(e) {
            if (e.keyCode == 27) {
                this.action_ClosePopup()
            }
        },
        updateHandleMouseEvent(isHandle) {
            this.isHandleMouseEvent = isHandle
        }
    }
}
</script>


<style scoped>
.work_code_color_picker {
    position: absolute;
    top: 180px;
    left: 100px;
}
</style>